import {
  ISelectionButton,
  ITwoRowGenericSelectorInp,
  TColors,
  TPatEvents,
  TPlayResults,
  TPlays,
} from '@/types';

export const TWO_PT_ATTEMPT_INP: ITwoRowGenericSelectorInp = {
  topOptions: [
    {
      text: TPatEvents.TWO_PT_RET_ONE_PT_SAFTEY,
      value: TPatEvents.TWO_PT_RET_ONE_PT_SAFTEY,
      color: TColors.INDIGO,
      col: 4,
    },
    {
      text: TPlayResults.TWO_PT_MADE,
      value: TPlayResults.TWO_PT_MADE,
      color: TColors.INDIGO,
      col: 4,
    },
    {
      text: TPlayResults.TWO_PT_MISS,
      value: TPlayResults.TWO_PT_MISS,
      color: TColors.INDIGO,
      col: 4,
    },
  ] as ISelectionButton[],
  topJustify: 'start',
  bottomJustify: 'space-between',
  bottomOptions: [
    {
      text: TPlayResults.TURNOVER,
      value: TPlayResults.TURNOVER,
      color: TColors.RED,
      isToggle: true,
      col: 4,
    },
    {
      text: TPlays.PENALTY_ALERT,
      value: TPlays.PENALTY_ALERT,
      color: TColors.ORANGE,
      isToggle: true,
      col: 4,
    },
  ] as ISelectionButton[],
};

export const XP_ATTEMPT_INP: ITwoRowGenericSelectorInp = {
  topJustify: 'start',
  bottomJustify: 'space-between',
  topOptions: [
    {
      text: TPatEvents.XP_RETURN,
      value: TPatEvents.XP_RETURN,
      color: TColors.INDIGO,
      col: 4,
    },
    {
      text: TPatEvents.XP_MISS,
      value: TPatEvents.XP_MISS,
      color: TColors.INDIGO,
      col: 4,
    },
    {
      text: TPatEvents.XP_MADE,
      value: TPatEvents.XP_MADE,
      color: TColors.INDIGO,
      col: 4,
    },
  ],
  bottomOptions: [
    {
      text: TPlayResults.TURNOVER,
      value: TPlayResults.TURNOVER,
      color: TColors.RED,
      isToggle: true,
      col: 4,
    },
    {
      text: TPlays.PENALTY_ALERT,
      value: TPlays.PENALTY_ALERT,
      color: TColors.ORANGE,
      isToggle: true,
      col: 4,
    },
  ],
};

export const TWO_PT_RET_ONE_PT_SAFTEY_INP: ITwoRowGenericSelectorInp = {
  bottomJustify: 'start',
  topJustify: 'start',
  topOptions: [
    {
      text: TPlayResults.ONE_PT_SAFTEY,
      value: TPlayResults.ONE_PT_SAFTEY,
      color: TColors.INDIGO,
      col: 6,
    },
    {
      text: TPlayResults.TWO_PT_RETURN,
      value: TPlayResults.TWO_PT_RETURN,
      color: TColors.INDIGO,
      col: 6,
    },
  ] as ISelectionButton[],
  bottomOptions: [
    {
      text: TPlayResults.TURNOVER,
      value: TPlayResults.TURNOVER,
      color: TColors.RED,
      isToggle: true,
      col: 4,
    },
    {
      text: TPlays.PENALTY_ALERT,
      value: TPlays.PENALTY_ALERT,
      color: TColors.ORANGE,
      isToggle: true,
      col: 4,
    },
  ] as ISelectionButton[],
};
